export default {
  pageTitle: 'Portfolio',
  metaDescription: 'See TEF\'s project portfolio by product, material, and country, showcasing thousands of pressure vessels and heat exchangers delivered worldwide.',
  hero: { title: 'Portfolio' },
  section: {
    heading: 'Portfolio',
    experiencedTitle: 'EXPERIENCED MATERIALS & EQUIPMENT',
    achievements: {
      title: 'ACHIEVEMENTS (1998 – SEP 2024)',
      projectsSuffix: 'PROJECTS',
      exportedPrefix: 'EXPORTED TO',
      countriesSuffix: 'COUNTRIES',
      fabricationPrefix: 'FABRICATION IS OVER',
      typeOfMaterialsSuffix: 'TYPE OF MATERIALS',
      customersPrefix: 'MORE THAN',
      customersSuffix: 'CUSTOMERS',
      plantsSuffix: 'PLANTS',
    },
    materialCategories: {
      title: 'MATERIAL CATEGORIES',
      examplePrefix: 'e.g.',
      niBaseAlloy: 'NI-BASE ALLOY',
      titaniumZirconium: 'TITANIUM & ZIRCONIUM',
      duplexSteel: 'DUPLEX STEEL',
      austeniticSS: 'AUSTENITIC SS',
      others: { name: 'OTHERS', example: 'Copper Nickel, Carbon Steel' },
    },
    applicationAreas: {
      title: 'APPLICATION AREAS',
      towerColumn: 'TOWER/COLUMN',
      vesselReactor: 'VESSEL/REACTOR',
      heatExchanger: 'HEAT EXCHANGER',
      piping: 'PIPING',
      muffle: 'MUFFLE',
      radiantTube: 'RADIANT TUBE',
      others: 'OTHERS',
    },
  },
  dashboard: {
    heading: 'Portfolio',
    subheading: 'DELIVERY RECORD MIX FROM 1998 - JULY 2024',
    byProduct: 'BY PRODUCT',
    byMaterial: 'BY MATERIAL',
    byCountry: 'BY COUNTRY',
  },
};
